export const hasGetParameter = (name: string) => new URL(window.location.href).searchParams.get(name) !== null;
